import { render, staticRenderFns } from "./InclusiveFooter.vue?vue&type=template&id=5463c43c&scoped=true&"
import script from "./InclusiveFooter.vue?vue&type=script&lang=js&"
export * from "./InclusiveFooter.vue?vue&type=script&lang=js&"
import style0 from "./InclusiveFooter.vue?vue&type=style&index=0&id=5463c43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463c43c",
  null
  
)

export default component.exports